import { useDemandeProformaStore } from '@/features/interface/demande/proforma/useDemandeProformaStore.ts'
import { type InjectionKey } from 'vue'
import { buildDemandeActions } from '../shared'

export type DemandeProformaActions = ReturnType<typeof useDemandeProformaActions>
export const PROFORMA_ACTIONS: InjectionKey<DemandeProformaActions> = Symbol('demande-inject')

export function useDemandeProformaActions() {
  const store = useDemandeProformaStore()
  // const { model } = storeToRefs(store)

  // typeDocumentTemplate: computed(() => 'ProForma')
  const actionsDemande = buildDemandeActions(store)

  return {
    ...actionsDemande,
  }
}
